import { Text, Box, Grid, AspectRatio, VStack } from '@chakra-ui/react'
import NextImage from 'next/image'

import Image from '@/features/Services/components/atoms/Images/Recruitment'

import {
  TITLE_H1_STYLE,
  TITLE_H2_STYLE,
  TITLE_H3_STYLE,
  PARAGRAPH_STYLE,
} from './style'

import { Policy } from '@/features/Services/types'

const HREF = 'serviceRecruitment'

const TITLE = 'Recruitment Privacy Policy'
const SUBTITLE = 'นโยบายการสรรหาและคัดเลือกบุคลากร'

const PRIMARY_COLOR = '#7977FC'
const SECONDARY_COLOR = '#FBFBFF'
const LINK_IMAGE = '/images/services/recruitment/4.png'
const GRADIENT = `linear-gradient(0deg, ${PRIMARY_COLOR}7F 0%, ${PRIMARY_COLOR}FF 100%)`

const POLICY: Policy[] = [
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        Recruitment
        <br />
        Privacy Policy
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        สำหรับองค์กรที่มีการเก็บรวบรวมหรือประมวลผล ข้อมูลส่วนบุคคลของผู้สมัครงาน
        เช่น ชื่อ-นามสกุล ประวัติการทำงาน ประวัติการศึกษา ประวัติสุขภาพ
        ไปจนถึงประวัติอาชญากรรม เพื่อเป็นหลักฐานใน
        การพิจารณาและคัดเลือกเพื่อว่าจ้างต่อไป
      </Text>
    ),
    image: '/images/services/recruitment/header.svg',
    imageAspectRatio: 645 / 654,
    button: {
      label: 'สร้าง Policy ตอนนี้!',
      href: '/create/policy?template=recruitment_privacy',
      logEvent: {
        ga: { category: TITLE, action: 'Click create policy' },
      },
    },
  },
  {
    title: (
      <Text as="h1" sx={TITLE_H2_STYLE}>
        Recruitment Privacy Policy
        <br />
        จำเป็นอย่างไร?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        เพื่อแจ้งวัตถุประสงค์และแนวปฏิบัติของการประมวลผลข้อมูลส่วนบุคคลตามพ.ร.บ.
        คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 สำหรับองค์กรที่มีการเก็บรวบรวม ใช้
        หรือ เปิดเผยข้อมูลส่วนบุคคลของผู้สมัครงาน
        ในกระบวนการก่อนการพิจารณาจ้างงาน เช่น การสมัครงาน การคัดเลือก
        และการสัมภาษณ์ ต้องจัดทำนโยบายการสรรหาและคัดเลือกบุคลากร (Recruitment
        Privacy Policy)
      </Text>
    ),
    image: '/images/services/recruitment/2.png',
    imageAspectRatio: 1,
  },
  {
    title: (
      <Text as="h2" sx={TITLE_H3_STYLE}>
        Recruitment Privacy Policy
        <br />
        ครอบคลุมเรื่องอะไรบ้าง?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        นโยบายการสรรหาและคัดเลือกบุคลากร ครอบคลุม การปฏิบัติ
        ไปจนถึงมาตรการจัดการด้านความปลอดภัย ของบริษัท
        เพื่อคุ้มครองข้อมูลส่วนบุคคลที่ได้เก็บ รวบรวม ใช้
        หรือเปิดเผยข้อมูลส่วนบุคคลของ ผู้สมัครงาน และบอกวัตถุประสงค์ภายใต้ฐาน
        ในการประมวลผลข้อมูล ตลอดจนสิทธิต่าง ๆ
        ของผู้สมัครงานที่เกี่ยวกับข้อมูลส่วนบุคคล
      </Text>
    ),
    checkList: [
      'ปรับใช้ได้กับทุกธุรกิจ',
      'สอดคล้องตามกฎหมาย PDPA',
      'สามารถคัดลอกลิงก์ไปใช้ได้เลย',
    ],
    image: <Image />,
  },
  {
    component: (
      <Box
        sx={{
          my: { base: 10, md: '70px', 'lg+': '100px' },
          px: 8,
        }}
      >
        <Text sx={{ ...TITLE_H2_STYLE, textAlign: 'center' }}>
          ใครที่ควรใช้ <br />
          Recruitment Privacy Policy ?
        </Text>
        <Grid
          sx={{
            maxW: '600px',
            mx: 'auto',
            gridTemplateColumns: { base: '1fr', md: 'repeat(2, 1fr)' },
            justifyItems: 'center',
            justifyContent: 'space-between',
            mt: { base: 10, md: '40px', 'lg+': '70px' },
            gridGap: 12,
          }}
        >
          <VStack spacing="6" sx={{ alignItems: 'center' }}>
            <AspectRatio ratio={1} sx={{ w: '150px' }}>
              <NextImage
                src="/images/services/recruitment/team-1.svg"
                layout="fill"
              />
            </AspectRatio>
            <Text sx={{ textAlign: 'center' }}>ทีมทรัพยากรบุคคล</Text>
          </VStack>
          <VStack spacing="6" sx={{ alignItems: 'center' }}>
            <AspectRatio ratio={1} sx={{ w: '150px' }}>
              <NextImage
                src="/images/services/recruitment/team-2.svg"
                layout="fill"
              />
            </AspectRatio>
            <Text sx={{ textAlign: 'center' }}>
              ผู้ที่มีหน้าที่รับผิดชอบในการสรรหา และคัดเลือกพนักงาน
            </Text>
          </VStack>
        </Grid>
      </Box>
    ),
  },
]

export default {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  POLICY,
  HREF,
  LINK_IMAGE,
  GRADIENT,
  TITLE,
  SUBTITLE,
}
